<div class="profile-container">
    <div class="">
        <div class="profile-content">
            <div class="personal-details">
              <div class="header-block">
                <div class="header-title">
                    <p>Existing Customer</p>
                </div>
                <div class="add-block">
                    <div class="search">
                        <form autocomplete="off" >
                            <input type="text" [ngModelOptions]="{standalone: true}" placeholder="search" [(ngModel)]="search">
                        </form>
                    </div>
                    <button  title="Add" (click)="openMapPopup()" data-toggle="modal" data-target="#addModal"><i class="bi bi-plus-lg"></i> Add</button>

                </div>
            </div>
              <!-- <div class="row">
                <div class="col-md-6 col-lg-6">
                  <select name="" id="" (change)="selectGroupType($event)" class="form-control">
                    <option value="" selected disabled> -- Select Group & Type --</option>
                    <option value="{{i}}" *ngFor="let object of groupTypeList;let i = index">group: {{object.group}},&nbsp;&nbsp;&nbsp; type: {{object.type}}</option>
                  </select>
                </div>
                <div class="col-md-3 col-lg-3" style="width:20%" >
                  <button (click)="filterByDeviceTypeAndGroup()" class="btn btn-primary">search</button>
                </div>
              </div> -->
                <div class="row">
                  <div class="col-md-9 col-lg-9">
                    <div class="map-container">
                      <div class="map-frame">
                        <div id="map">
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3 col-lg-3" style="padding-left: 0;">
                    <div class="customerList">
                      <p *ngFor="let list of routeData | filter:search;let i = index " (click)="getExistingCustomerById(list.existingCustomerInfoId)">{{list.name}} - {{list.serialNumber}}</p>
                    </div>
                  </div>
                </div>
            
            </div>
  
        </div>
    </div>
  </div>


  <div class="prospect-block" *ngFor="let data of data">
    <div class="prospect-content">
      <div class="application-details">
        <p class="application-title">Personal Details:</p>
        <div class="row application-form-details">
          <div class="col-md-4 col-lg-4 application-form">
            <label for="">customer Id</label>
            <p>{{data.customerId}}</p>
          </div>
          <div class="col-md-4 col-lg-4 application-form">
            <label for="">Name</label>
            <p *ngIf="data.name != ''">{{data.name}}</p>
            <p *ngIf="data.name == ''">--</p>
          </div>
          <div class="col-md-4 col-lg-4 application-form">
            <label for="">Mobile</label>
            <p>{{data.mobileNo}}</p>
          </div>
          <div class="col-md-4 col-lg-4 application-form">
            <label for="">Alternate Mobile</label>
            <p *ngIf="data.altMobileNo != ''">{{data.altMobileNo}}</p>
            <p *ngIf="data.altMobileNo == ''">--</p>
          </div>
          <div class="col-md-4 col-lg-4 application-form">
            <label for="">Email</label>
            <p *ngIf="data.email != ''">{{data.email}}</p>
            <p *ngIf="data.email == ''">--</p>
          </div>
          <div class="col-md-4 col-lg-4 application-form">
            <label for="">Alternate Email</label>
            <p *ngIf="data.altEmail != ''">{{data.altEmail}}</p>
            <p *ngIf="data.altEmail == ''">--</p>
          </div>
          <div class="col-md-4 col-lg-4 application-form">
            <label for="">Installation Address</label>
            <p *ngIf="data.installationAddress != ''">{{data.installationAddress}}</p>
            <p *ngIf="data.installationAddress == ''">--</p>
          </div>

          <div class="col-md-4 col-lg-4 application-form">
            <label for="">Application Form For</label>
            <p *ngIf="data.applicationFormFor != ''">{{data.applicationFormFor}}</p>
            <p *ngIf="data.applicationFormFor == ''">--</p>
          </div>

          <div class="col-md-4 col-lg-4 application-form">
            <label for="">Status</label>
            <p *ngIf="data.latestStatus != ''">{{data.latestStatus}}</p>
            <p *ngIf="data.latestStatus == ''">--</p>
          </div>
        </div>
      </div>

  

      <div class="identity-proof-details">
        <p class="identity-proof-title">Building Proof:</p>
        <div class="row identity-proof-form-details">
          <div class="col-md-12 col-lg-12 identity-proof-form">
            <div class="proof-images">
              <div class="image">
                <img src="{{data.buildingUrl}}" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>


      <div class="identity-proof-details">
        <p class="identity-proof-title">Identity Proof:</p>
        <div class="row identity-proof-form-details">
          <div class="col-md-12 col-lg-12 identity-proof-form">
            <div class="proof-images">
              <div class="image">
                <img src="{{data.idProofUrl}}" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="identity-proof-details">
        <p class="identity-proof-title">Photo Proof:</p>
        <div class="row identity-proof-form-details">
          <div class="col-md-12 col-lg-12 identity-proof-form">
            <div class="proof-images">
              <div class="image">
                <img src="{{data.photoUrl}}" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="identity-proof-details">
        <p class="identity-proof-title">Address Proof:</p>
        <div class="row identity-proof-form-details">
          <div class="col-md-12 col-lg-12 identity-proof-form">
            <div class="proof-images">
              <div class="image">
                <img src="{{data.addressProofUrl}}" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="applicant-details" *ngFor="let list of data.deviceInfoList">
        <p class="applicant-title">Device Details:</p>
        <div class="row applicant-form-details">
          <div class="col-md-4 col-lg-4 applicant-form">
            <label for="">Device Id</label>
            <p *ngIf="list.deviceId != ''">{{list.deviceId}}</p>
            <p *ngIf="list.deviceId == ''">--</p>
          </div>
          <div class="col-md-4 col-lg-4 applicant-form">
            <label for="">Device Type</label>
            <p *ngIf="list.deviceType != ''">{{list.deviceType}}</p>
            <p *ngIf="list.deviceType == ''">--</p>
          </div>
          <div class="col-md-4 col-lg-4 applicant-form">
            <label for="">Device Info</label>
            <p *ngIf="list.deviceInfo != ''">{{list.deviceInfo}}</p>
            <p *ngIf="list.deviceInfo == ''">--</p>
          </div>
        
          <div class="col-md-4 col-lg-4 applicant-form devive-proof-form">
            <label for="">Device Photo</label>
            <div class="proof-images" *ngIf="list.devicePhotoUrl != ''">
              <div class="image">
                <img src="{{list.devicePhotoUrl}}" alt="">
              </div>
            </div>
            <p *ngIf="list.devicePhotoUrl == ''">--</p>

          </div>
        </div>
      </div>

    </div>
  </div>








<div class="modal fade" id="addModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Add Existing Customer
          <span data-dismiss="modal">
            <i class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <div>
      

      <div class="main">
        <div class="form container">
          <!-- <div class="form-title">
            <div>
              <h3 class="text-center">RVR DIGITAL INFRASTRUCTURES LIMITED</h3>
              <p class="text-center">2ND FLOOR, MAGNA TOWERS, OPP INDIAN OIL BUNK ROAD, MADHAPUR, HYDERABAD - 500 081</p>
            </div>
          </div> -->
          <div class="offers-area">
          </div>
          <div class="form-fields">
            <form [formGroup]="form">
      
              <div class="field">
                <span>Phone<span class="star">*</span></span>
                <div class="input-group input-group-sm">
                  <div class="input-group input-group-sm w-100">
                    <input type="number" class="form-control" [readonly]="PhoneInput" aria-label="Username" formControlName="mobileNo" placeholder="please enter phone number" aria-describedby="basic-addon1">
                    <span style="width: 10px;" *ngIf="form.get('mobileNo').valid"></span>
                    <button *ngIf="form.get('mobileNo').valid && !phoneotp" class="verify" (click)="verifyPhone()" >Click here to get OTP</button>
                    <button class="verify" *ngIf="timer1">{{minutesToDday}} : {{secondsToDday}}</button>
                    <button class="verify" *ngIf="resendOtp1" (click)="verifyPhone()">Click here to resend OTP</button>
                    <button class="verify" *ngIf="phoneverify"><i class="far fa-check-circle pr-1"></i> verified</button>
                  </div>
                  <div class="input-group input-group-sm mt-2 w-100" *ngIf="phone">
                    <input type="number" [(ngModel)]="vphoneOtp" [ngModelOptions]="{standalone: true}" class="form-control" placeholder="enter otp" aria-label="Username" aria-describedby="basic-addon1">
                    <span style="width: 10px;"> </span> <button class="verify" (click)="phoneOtp()">Click here to verify OTP</button>
                  </div>
                </div>
              </div>
      
              <div class="field fll">
                <span>Name <span class="star">*</span></span>
                <div class="input-group input-group-sm">
                  <div class="input-group input-group-sm w-100">
                    <input type="text" class="form-control" aria-label="Username" formControlName="name" placeholder="please enter name" aria-describedby="basic-addon1">
                  </div>
                </div>
              </div>
      
              <div class="field">
                <span>Customer Id<span class="star">*</span></span>
                  <div class="input-group input-group-sm">
                    <div class="input-group input-group-sm w-100">
                    <input type="text" class="form-control" formControlName="customerId" placeholder="please enter customer Id" aria-describedby="basic-addon1">
                    <span *ngIf="form.submitted&&(form.get('customerId')?.value==null||form.get('customerId')?.value=='')" class="danger">Customer Id is required</span>
                  </div>
                </div>
              </div>
    
              <div class="field fll">
                <span>Email <span class="star">*</span></span>
                <div class="input-group input-group-sm">
                  <div class="input-group input-group-sm w-100">
                    <input type="text" class="form-control" aria-label="Username" formControlName="email" placeholder="please enter email" aria-describedby="basic-addon1">
                  </div>
                </div>
              </div>
      
              <div class="field">
                <span>Application Form For <span class="star">*</span></span>
                <div class="input-group input-group-sm">
                  <div class="input-group input-group-sm w-100">
                    <select name="" id="" class="form-control w-100" formControlName="applicationFormFor">
                      <option selected disabled value="">select application form for</option>
                      <option value="Cable">Cable</option>
                      <option value="Internet">Internet</option>
                      <option value="Internet & Cable">Internet & Cable</option>
                      <option value="Upgrade to FTTH">Upgrade to FTTH</option>
                    </select>
                  </div>
                </div>
              </div>
    
              <div class="field fll free-internet" *ngIf="form.get('applicationFormFor').value == 'Cable'">
                <div class="">
                  <input type="checkbox" (click)="freeInternet($event)">
                  <label for="">Rs.1/- Internet offer</label>
                </div>
              </div>
      
              <div class="field">
                <span>Installation Address <span class="star">*</span></span>
                <div class="input-group input-group-sm">
                  <textarea name="" id="" cols="30" class="form-control" formControlName="installationAddress" placeholder="please enter installation address" rows="2"></textarea>
                </div>
              </div>


              <div class="field">
                <span>Asset <span class="star">*</span></span>
                <div class="input-group input-group-sm">

                  <ng-multiselect-dropdown
                          [placeholder]="'select assets'"
                          [settings]="assetDropdownSettings"
                          [data]="objectInfoList"
                          [(ngModel)]="assetSelectedList"
                          class="form-control"
                          style="padding: 0;border: none;z-index: 999;"
                          [ngModelOptions]="{standalone: true}"
                          (onSelect)="onItemSelect($event)"
                          (onSelectAll)="onSelectAll($event)"
                          >
                      </ng-multiselect-dropdown>
                </div>
              </div>



              <div class="field">
                <span>Location <span class="star">*</span></span>
                <div class="input-group input-group-sm">
                  <select name="" id="" [ngModelOptions]="{standalone: true}" [(ngModel)]="location" class="form-control">
                    <option value="" selected disabled> -- select location --</option>
                    <option value="{{loc.zone}}" *ngFor="let loc of locationList">{{loc.zone}} - {{loc.city}} - {{loc.postalCode}}</option>
                  </select>
                </div>
              </div>

                 

              


      
              <div class="field fll">
                <span>Photo <span class="star">*</span>
                <br>
                <p class="note">(Note: Allowed extensions are jpg, jpeg, png and file size should be less than 10MB)</p>
                <button (click)="removeImage('photoUrl')" *ngIf="photoUrl != ''">Remove</button>
                </span>
                <button *ngIf="photoUrlLoading">Loading Image</button>
                <div hidden="true">
                  <input type="file" id="photoUrl" accept="image/*"  (change)="onChange($event,'photoUrl')">
                </div>
    
                <button *ngIf="photoUrl == '' && !photoUrlLoading" (click)="addImageBtn('photoUrl')">Add Image</button>
                <img [src]="photoUrl" class="url2" *ngIf="photoUrl != ''" alt="">
              </div>
      
              <div class="field">
                <span>Identity Proof<span class="star">*</span>
                <br>
                <p class="note">(Note: Allowed extensions are jpg, jpeg, png and file size should be less than 10MB)</p>
                <button (click)="removeImage('idProofUrl')" *ngIf="idProofUrl != ''">Remove</button>
    
                </span>
                <button *ngIf="idProofUrlLoading">Loading Image</button>
                <div hidden="true">
                  <input type="file" id="idProofUrl" accept="image/*"  (change)="onChange($event,'idProofUrl')">
                </div>

                <button *ngIf="idProofUrl == '' && !idProofUrlLoading" (click)="addImageBtn('idProofUrl')">Add Image</button>
                <img [src]="idProofUrl" class="url1" *ngIf="idProofUrl != ''" alt="">
              </div>
      
              <div class="field fll">
                <span>Address Proof <span class="star">*</span>
                <br>
                <p class="note">(Note: Allowed extensions are jpg, jpeg, png and file size should be less than 10MB)</p>
                <button (click)="removeImage('addressProofUrl')" *ngIf="addressProofUrl != ''">Remove</button>
    
                </span>
                <button *ngIf="addressProofUrlLoading">Loading Image</button>
                <div hidden="true">
                  <input type="file" id="addressProofUrl" accept="image/*" hidden="true" (change)="onChange($event,'addressProofUrl')">
                </div>
    
                <button *ngIf="addressProofUrl == '' && !addressProofUrlLoading" (click)="addImageBtn('addressProofUrl')">Add Image</button>
                <img [src]="addressProofUrl" class="url2" *ngIf="addressProofUrl != ''" alt="">
              </div>
      
              <div class="field ">
                <span>Building Photo<span class="star">*</span>
                <br>
                <p class="note">(Note: Allowed extensions are jpg, jpeg, png and file size should be less than 10MB)</p>
                <button (click)="removeImage('buildingUrl')" *ngIf="buildingUrl != ''">Remove</button>
    
                </span>
                <button *ngIf="buildingUrlLoading">Loading Image</button>
                <div hidden="true">
                  <input type="file" id="buildingUrl" accept="image/*" hidden="true" (change)="onChange($event,'buildingUrl')">
                </div>
                <button *ngIf="buildingUrl == '' && !buildingUrlLoading" (click)="addImageBtn('buildingUrl')">Add Image</button>
                <img [src]="buildingUrl" class="url1" *ngIf="buildingUrl != ''" alt="">
              </div>
    
    
    
    
    
    
          
    
    
    
              <div formArrayName="deviceInfoList">
                <div *ngFor="let object of form.controls.deviceInfoList['controls'];let i = index;let last = last" [formGroupName]="i">
                  <div class="field fll">
                    <span>Device Id <span class="star">*</span></span>
                    <div class="input-group input-group-sm">
                      <div class="input-group input-group-sm w-100">
                        <input type="text" class="form-control" aria-label="Username" formControlName="deviceId" placeholder="please enter device Id" aria-describedby="basic-addon1">
                      </div>
                    </div>
                  </div>
          
                  <div class="field ">
                    <span>Device Type <span class="star">*</span></span>
                    <div class="input-group input-group-sm">
                      <div class="input-group input-group-sm w-100">
                        <input type="text" class="form-control" aria-label="Username" formControlName="deviceType" placeholder="please enter device type" aria-describedby="basic-addon1">
                      </div>
                    </div>
                  </div>
          
                  <div class="field fll">
                    <span>Device Info</span>
                    <div class="input-group input-group-sm">
                      <div class="input-group input-group-sm w-100">
                        <input type="text" class="form-control" aria-label="Username" formControlName="deviceInfo" placeholder="please enter device info" aria-describedby="basic-addon1">
                      </div>
                    </div>
                  </div>
    
    <div class="field">
  <span>
    Device Photo<span class="star">*</span>
    <br>
    <p class="note">(Note: Allowed extensions are jpg, jpeg, png and file size should be less than 10MB)</p>
    <button 
      (click)="removeDeviceImage(i)" 
      *ngIf="infoList.controls[i].get('devicePhotoUrl')?.value != ''">
      Remove
    </button>
  </span>

  <button 
    *ngIf="infoList.controls[i].get('devicePhotoUrlLoading')?.value">
    Loading Image
  </button>
  <div hidden="true">
    <input 
      type="file" 
      id="devicePhotoUrl{{i}}" 
      accept="image/*" 
      hidden="true" 
      (change)="onChangeDevice($event, i)"> 
  </div>


  <button 
    *ngIf="infoList.controls[i].get('devicePhotoUrl')?.value == '' 
            && !infoList.controls[i].get('devicePhotoUrlLoading')?.value" 
    (click)="addDeviceImageBtn(i)">
    Add Image
  </button>

  <img 
    [src]="infoList.controls[i].get('devicePhotoUrl')?.value" 
    class="url1" 
    *ngIf="infoList.controls[i].get('devicePhotoUrl')?.value != ''" 
    alt="">
</div>

    
    
    
                  <div class="add-remove-buttons" *ngIf="last">
                    <button (click)="addDeviceInfoList()">add</button>
                    <button *ngIf="i!=0" (click)="removeDeviceInfoList(i)">remove</button>
                  </div>
                  <div class="add-remove-buttons" *ngIf="!last">
                    <button (click)="removeDeviceInfoList(i)">remove</button>
                  </div>
                </div>
            </div>
              <!-- <input class="pr-2" type="checkbox" name="" id="" [checked]="isChecked" (click)="checked()"> <p class="term">I have read, understood & accepted the <span class="link">Terms and Conditions.</span></p><br>
              <button (click)="customerRegistration()" class="submit">submit</button> -->
            </form>
          </div>
        </div>
      </div>


<div class="map-frame">
  <div id="map1">

  </div>
  <!-- <div class="map-latlng" *ngIf="isLatLng">
    <button (click)="removeLatLng()">{{ 'generic.remove' | translate }}</button>
  </div> -->
</div>

        
        </div>
        <div class="modal-footer">
          <button type="button" id="closeModalButton1" class="btn btn-secondary" data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
          <button type="button" class="btn btn-primary">{{ 'generic.add' | translate }}</button>
        </div>
      </div>
    </div>
  </div>
</div>





<button id="viewB" hidden="true" data-toggle="modal" data-target="#viewCustomer"></button>
  <div class="modal fade" id="viewCustomer" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
      <div class="modal-content">

      <div class="modal-header">
        <h5 class="modal-title" id="viewModalLabel">Personal Details:
          <span data-dismiss="modal">
            <i class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>
        <div class="prospect-block" *ngFor="let data of customerData">
          <div class="prospect-content">
            <div class="application-details">
              <!-- <p class="application-title">Personal Details:</p> -->
              <div class="row application-form-details">
                <div class="col-md-4 col-lg-4 application-form">
                  <label for="">customer Id</label>
                  <p>{{data.customerId}}</p>
                </div>
                <div class="col-md-4 col-lg-4 application-form">
                  <label for="">Name</label>
                  <p *ngIf="data.name != ''">{{data.name}}</p>
                  <p *ngIf="data.name == ''">--</p>
                </div>
                <div class="col-md-4 col-lg-4 application-form">
                  <label for="">Mobile</label>
                  <p>{{data.mobileNo}}</p>
                </div>
                <div class="col-md-4 col-lg-4 application-form">
                  <label for="">Alternate Mobile</label>
                  <p *ngIf="data.altMobileNo != ''">{{data.altMobileNo}}</p>
                  <p *ngIf="data.altMobileNo == ''">--</p>
                </div>
                <div class="col-md-4 col-lg-4 application-form">
                  <label for="">Email</label>
                  <p *ngIf="data.email != ''">{{data.email}}</p>
                  <p *ngIf="data.email == ''">--</p>
                </div>
                <div class="col-md-4 col-lg-4 application-form">
                  <label for="">Alternate Email</label>
                  <p *ngIf="data.altEmail != ''">{{data.altEmail}}</p>
                  <p *ngIf="data.altEmail == ''">--</p>
                </div>
                <div class="col-md-4 col-lg-4 application-form">
                  <label for="">Installation Address</label>
                  <p *ngIf="data.installationAddress != ''">{{data.installationAddress}}</p>
                  <p *ngIf="data.installationAddress == ''">--</p>
                </div>

                <div class="col-md-4 col-lg-4 application-form">
                  <label for="">Application Form For</label>
                  <p *ngIf="data.applicationFormFor != ''">{{data.applicationFormFor}}</p>
                  <p *ngIf="data.applicationFormFor == ''">--</p>
                </div>

                <div class="col-md-4 col-lg-4 application-form">
                  <label for="">Status</label>
                  <p *ngIf="data.latestStatus != ''">{{data.latestStatus}}</p>
                  <p *ngIf="data.latestStatus == ''">--</p>
                </div>
              </div>
            </div>
  
            <div class="big-image" *ngIf="imageUrl != ''">
              <div class="image">
                <div class="close-x">
                  <i class="bi bi-x-lg" (click)="closeImage()"></i>
                </div>
                <img src="{{imageUrl}}" alt="">
              </div>
            </div>
            <div class="row">
              <div class="identity-proof-details col-md-3 col-lg-3">
                <p class="identity-proof-title">Building Proof:</p>
                <div class=" identity-proof-form-details">
                  <div class=" identity-proof-form">
                    <div class="proof-images">
                      <div class="image">
                        <img src="{{data.buildingUrl}}" (click)="imageUrlSelect(data.buildingUrl)" alt="">
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="identity-proof-details col-md-3 col-lg-3">
                <p class="identity-proof-title">Identity Proof:</p>
                <div class="row identity-proof-form-details">
                  <div class=" identity-proof-form">
                    <div class="proof-images">
                      <div class="image">
                        <img src="{{data.idProofUrl}}" (click)="imageUrlSelect(data.idProofUrl)" alt="">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
  
              <div class="identity-proof-details col-md-3 col-lg-3">
                <p class="identity-proof-title">Photo Proof:</p>
                <div class="row identity-proof-form-details">
                  <div class=" identity-proof-form">
                    <div class="proof-images">
                      <div class="image">
                        <img src="{{data.photoUrl}}" (click)="imageUrlSelect(data.photoUrl)" alt="">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
  
              <div class="identity-proof-details col-md-3 col-lg-3">
                <p class="identity-proof-title">Address Proof:</p>
                <div class="row identity-proof-form-details">
                  <div class=" identity-proof-form">
                    <div class="proof-images">
                      <div class="image">
                        <img src="{{data.addressProofUrl}}" (click)="imageUrlSelect(data.addressProofUrl)" alt="">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
           
            <div class="applicant-details" *ngFor="let list of data.deviceInfoList">
              <p class="applicant-title">Device Details:</p>
              <div class="row applicant-form-details">
                <div class="col-md-4 col-lg-4 applicant-form">
                  <label for="">Device Id</label>
                  <p *ngIf="list.deviceId != ''">{{list.deviceId}}</p>
                  <p *ngIf="list.deviceId == ''">--</p>
                </div>
                <div class="col-md-4 col-lg-4 applicant-form">
                  <label for="">Device Type</label>
                  <p *ngIf="list.deviceType != ''">{{list.deviceType}}</p>
                  <p *ngIf="list.deviceType == ''">--</p>
                </div>
                <div class="col-md-4 col-lg-4 applicant-form">
                  <label for="">Device Info</label>
                  <p *ngIf="list.deviceInfo != ''">{{list.deviceInfo}}</p>
                  <p *ngIf="list.deviceInfo == ''">--</p>
                </div>
              
                <div class="col-md-4 col-lg-4 applicant-form devive-proof-form">
                  <label for="">Device Photo</label>
                  <div class="proof-images" *ngIf="list.devicePhotoUrl != ''">
                    <div class="image">
                      <img src="{{list.devicePhotoUrl}}" (click)="imageUrlSelect(list.devicePhotoUrl)" alt="">
                    </div>
                  </div>
                  <p *ngIf="list.devicePhotoUrl == ''">--</p>

                </div>
              </div>
            </div>
  
          </div>
          <div class="modal-footer">
            <button type="button" id="closeModalButton" class="btn btn-secondary" data-dismiss="modal" class="btn btn-secondary">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>